import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {
  files: any[] = [];
  showError = false;
  @ViewChild('fileDropRef', { static: false }) fileDropEl!: ElementRef;

  @Output() uploadedFile = new EventEmitter<any>();
  @Input() isDismissable: boolean = false;

  formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  onFileDropped(files: any) {
    this.uploadedFile.emit(files);
  }

  fileBrowseHandler(event: any) {
    this.uploadedFile.emit(event.files[0]);
  }
}
